import React, {StrictMode, useEffect, useRef} from "react";
import {Text} from "../AssetReferences";
import s from "./about_page_styles.module.css"
import {AboutOrganism, Credits, Donate, Intro} from "./about_page_text";


export default function AboutPage({display, OnExit}) {
    
    // hold ref to back button in order to shift focus to it for keyboard navigation    
    const backButtonRef = useRef(null);
    useEffect(() => {
        if (display && backButtonRef.current) {
            backButtonRef.current.focus({focusVisible: true});
        }
    }, [display]);

    function backButtonUpdateRef(btnElement) {
        backButtonRef.current = btnElement;
    }

    return (
        <div id={"aboutPageContainer"}
             className={s.about_page_container}
        >
            <div
                className={s.outside}
                onClick={OnExit}
                style={{display: display ? "block" : "none"}}
            />

            <div id={"aboutPage"}
                 className={s.about_page}
                 style={{display: display ? "block" : "none"}}
            >
                <BackButton onPress={OnExit} setRef={backButtonUpdateRef}/>

                <Header/>

                <div className={s.content}>                    
                    <Intro/>
                    <Credits/>
                    <AboutOrganism/>
                    <Donate/>
                </div>
            </div>
        </div>
    )
}

function Header() {
    return (
        <div className={s.header}>
            Symbiosis
        </div>
    )
}

function BackButton({setRef, onPress}) {
    const self = useRef(null)
    
    useEffect(() => {
        setRef(self.current)
    }, [self]);
    
    return (
        <div id={"back button container"} style={{textAlign: "right"}}>
            <button id={"back button"} ref={self} className={s.close_button} onClick={onPress}>
                back
            </button>
        </div>
    )
}


